import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { ManagementStoreActions } from '../management-store';

@Injectable({ providedIn: 'root' })
export class ManagementResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    this.store.dispatch(ManagementStoreActions.ManagementTokensVppResolverActions.requested());
    this.store.dispatch(ManagementStoreActions.ManagementTokensDepResolverActions.requested());
    this.store.dispatch(ManagementStoreActions.ManagementTokensPushResolverActions.requested());
    this.store.dispatch(ManagementStoreActions.ManagementTokensVendorResolverActions.requested());
    return of(true);
  }
}
